if (!customElements.get("included-optional-component")) {
  customElements.define(
    "included-optional-component",
    class IncludedOptionalProducts extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        var this2 = this;
        var csvurl = $(".included-component-wrapper").data("csvfile");
        var href = new URL(csvurl);
        var random = Math.floor(Math.random() * 100000000);
        href.searchParams.set("v", random);
        csvurl = href.toString();
        var csvurlfit = $(".included-component-wrapper").data("csvfilefit");
        var hreffit = new URL(csvurlfit);
        hreffit.searchParams.set("v", random);
        csvurlfit = hreffit.toString();
        $.ajax({
          type: "HEAD",
          url: csvurlfit,
          success: function () {
            this2.loaddata(csvurlfit);
          },
          error: function () {
            this2.loaddata(csvurl);
          },
        });
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata(csvurl) {
        var family = $(".included-component-wrapper").data("family");

        var jsonarr = [];

        var this3 = this;

        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["fabric"] = word_array[index][1].replace(/[^a-zA-Z0-9 ]/g, "");
              ob["name"] = word_array[index][2];
              ob["handle"] = word_array[index][3];
              ob["quantity"] = word_array[index][4];
              ob["included"] = word_array[index][5];
              jsonarr.push(ob);
            }

            setDataInPage(jsonarr);
          },
        });

        function setDataInPage(data) {
          var tags = $(".included-component-wrapper").data("tags");
          var artags = tags.split(",");
          var arinitial = [];
          for (let i = 0; i < artags.length; i++) {
            var tag = artags[i].split("_");
            if (tag[0] == "CATEGORY") {
              arinitial.push(tag[1]);
            }
            if (tag[0] == "FABRIC") {
              arinitial.push(tag[1].replace(/[^a-zA-Z0-9 ]/g, ""));
            }
          }

          var found = false;
          var currentdata = [];
          for (let i = 0; i < data.length; i++) {
            if (
              arinitial.includes(data[i]["category"]) &&
              arinitial.includes(data[i]["fabric"])
            ) {
              found = true;
              currentdata.push(data[i]);
            }
          }

          if (currentdata.length > 0) {
            var index = 0;
            loadProducts(index);
            function loadProducts(index) {
              var str = "";
              var indata = currentdata[index];
              jQuery.getJSON(
                window.Shopify.routes.root +
                  "products/" +
                  indata["handle"] +
                  ".js",
                function (product) {
                  var price = product.price / 100;
                  price = price.toFixed(2);
                  var prices = "$" + price;
                  var addqty = "";
                  var icon = "";
                  if (indata["included"] == "1") {
                    prices = "Free";
                    addqty = 'style="pointer-events:none;display:none;"';
                   
                  }else{
                     icon = `<div class="icon-box"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.5 0.125C14.741 0.125 15.75 1.13398 15.75 2.375V13.625C15.75 14.866 14.741 15.875 13.5 15.875H2.25C1.00898 15.875 0 14.866 0 13.625V2.375C0 1.13398 1.00898 0.125 2.25 0.125H13.5ZM11.25 10.018V5.1875C11.25 4.87812 10.9969 4.625 10.6875 4.625H5.85703C5.41758 4.625 5.0625 4.98008 5.0625 5.41953C5.0625 5.63047 5.14688 5.83438 5.29453 5.98203L6.46875 7.15625L4.13789 9.48711C4.00781 9.61719 3.9375 9.78945 3.9375 9.96875C3.9375 10.148 4.00781 10.3203 4.13789 10.4504L5.42812 11.7406C5.55469 11.8672 5.72695 11.941 5.90977 11.941C6.09258 11.941 6.26133 11.8707 6.39141 11.7406L8.71875 9.40625L9.89297 10.5805C10.0406 10.7281 10.2445 10.8125 10.4555 10.8125C10.8949 10.8125 11.25 10.4574 11.25 10.018Z" fill="#333333"/>
                          </svg>
                        </div>`;
                  }

                  var varid = product.variants[0].id;

                  str =
                    str +
                    `<div
                        class="component-item"
                        data-included = "${indata["included"]}"
                        data-productid="${varid}"
                        data-mainpid="${product.handle}"
                        data-productname="product_${index}"
                        data-price="${price}"
                      >
                        <div class="component-pro-wrapper">
                          <div class="image-container">
                          ${icon}
                            <img src="${product.images[0]}">
                          </div>
                          <div class="main-pro-title">
                          <div class="pro-title">${indata["name"]}</div>
                          
                          </div>
                          <div class="component-quantity" ${addqty}>
                            <div class="number">
                              <span class="minus"></span>
                              <input type="number" class="component-qty component-qty-main" min="0" value="0" step="${indata["quantity"]}">
                              <span class="plus"></span>
                            </div>
                          </div> 
                          <div class="component-price component-price-main">${prices}</div>
                           
                            <div class="main-mini-popup description-popup">
                              <div class="backgroundpopupcross"></div>
                                <div class="mini-popup-wrapper description-model-wrapper">
                                  <div class="mini-popup-close">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                    <path d="M7.5 7.5L52.5 52.5M52.5 7.5L7.5 52.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                  </svg>
                                  </div>
                                  <div class="main-description-wrapper">
                                  <div class="image-wrapper">
                                    <img src="${product.images[0]}">
                                  </div>
                                  <div class="product-desc-wrapper">
                                    <div class="product-title">${product.title}</div>
                                    <div class="component-price">${prices}</div>
                                    <div class="product-desc">${product.description}</div>
                                    <div style="display:none;" class="component-quantity" ${addqty}>
                                      <div class="number">
                                        <span class="minus"></span>
                                        <input type="number" class="component-qty" min="0" value="0" step="${indata["quantity"]}">
                                        <span class="plus"></span>
                                      </div>
                                    </div> 
                                </div>
                                </div>
                              </div> 
                          </div>
                        </div>
                      </div>`;
                  if (indata["included"] == "1") {
                    $(".included-component-wrapper-free").append(str);
                  } else {
                    $(".included-component-wrapper").append(str);
                  }

                  if (index < currentdata.length - 1) {
                    index++;
                    loadProducts(index);
                  } else {
                    if ($('.component-item[data-included="1"]').length <= 0) {
                      $(".add-on-free-products").hide();
                    }
                    if ($('.component-item[data-included="0"]').length <= 0) {
                      $(".add-on-paid-products").hide();
                    }
                    $(".included-component-wrapper")
                      .parents("included-optional-component")
                      .addClass("included-optional-component");
                    $(".included-component-wrapper")
                      .parents("included-optional-component")
                      .css("display", "block");

                    $(".included_free_label").show();
                    $(".model-add-to-cart,.included-add-to-cart")
                      .unbind()
                      .click(function (params) {
                        const config = fetchConfig("javascript");
                        config.headers["X-Requested-With"] = "XMLHttpRequest";
                        delete config.headers["Content-Type"];
                        const formData = new FormData();
                        if (this3.cart) {
                          formData.append(
                            "sections",
                            this3.cart
                              .getSectionsToRender()
                              .map((section) => section.id)
                          );
                          formData.append(
                            "sections_url",
                            window.location.pathname
                          );
                          this3.cart.setActiveElement(document.activeElement);
                        }
                        var quantity = $(this)
                          .parent()
                          .find(".component-qty")
                          .val();
                        formData.append("id", $(this).data("varid"));
                        formData.append("quantity", quantity);
                        config.body = formData;

                        var this2 = this;
                        $(
                          this
                        ).html(`<div class="loading-overlay__spinner" bis_skin_checked="1">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle style="stroke:white;" class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>`);

                        fetch(`${routes.cart_add_url}`, config)
                          .then((response) => response.json())
                          .then((response) => {
                            if (response.status) {
                              $(this2).after(
                                `<div class="error-message-upsell" style="font-weight:500;margin-top:10px;line-height:1.6;color:red;font-size:12px;text-align:center;">${response.description}</div>`
                              );
                              return;
                            } else if (!this3.cart) {
                              window.location = window.routes.cart_url;
                              return;
                            }
                            this3.cart.renderContents(response);
                            $(this).parents(".included-modal").hide();
                          })
                          .catch((e) => {
                            console.error(e);
                          })
                          .finally(() => {
                            if (
                              $(this)
                                .parent()
                                .hasClass("included-modal-content")
                            ) {
                              $(this2).html("Add To Cart");
                            } else {
                              $(this2).html("ADD");
                            }
                          });
                      });
                    $(".component-pro-wrapper .image-container").click(
                      function () {
                        $(this).parent().find(".main-mini-popup").fadeIn();
                        $(this)
                          .parent()
                          .find(".main-mini-popup")
                          .addClass("active");
                      }
                    );
                    $(".component-pro-wrapper .pro-title").click(function () {
                      $(this)
                        .parents(".component-item")
                        .find(".main-mini-popup")
                        .fadeIn();
                      $(this)
                        .parent()
                        .find(".main-mini-popup")
                        .addClass("active");
                    });
                    $(".mini-popup-close").click(function () {
                      $(this)
                        .parents(".component-item")
                        .find(".main-mini-popup")
                        .fadeOut();
                      $(this)
                        .parents(".component-item")
                        .find(".main-mini-popup")
                        .removeClass("active");
                    });
                    $(".backgroundpopupcross").click(function () {
                      $(this)
                        .parents(".component-item")
                        .find(".main-mini-popup")
                        .fadeOut();
                      $(this)
                        .parents(".component-item")
                        .find(".main-mini-popup")
                        .removeClass("active");
                    });

                    $(".minus").on("click", function () {
                      var $input = $(this).parent().find("input");
                      var $step = Number(
                        $(this).parent().find("input").attr("step")
                      );
                      var count = parseInt($input.val()) - $step;

                      count = count < 0 ? 0 : count;
                      $input.val(count);
                      $input.change();
                      updateTotal();

                      return false;
                    });

                    $(".plus").on("click", function () {
                      var $input = $(this).parent().find("input");
                      var $step = Number(
                        $(this).parent().find("input").attr("step")
                      );
                      var count = parseInt($input.val()) + $step;

                      $input.val(parseInt($input.val()) + $step);
                      $input.change();
                      updateTotal();
                      return false;
                    });

                    function updateTotal(quantity) {
                      $(".component-item").each(function () {
                        var quantityElement = $(this).find(
                          ".component-quantity .number"
                        );
                        var input = quantityElement.find("input");
                        var quantity = parseFloat(input.val()) || 0;
                        $(this)
                          .find(".included-modal .component-qty")
                          .val(quantity);
                        if (
                          quantity > 0 &&
                          $(this).attr("data-included") != 1
                        ) {
                          var price = parseFloat($(this).data("price"));
                          var calprice = quantity * price;

                          $(this)
                            .find(
                              ".component-pro-wrapper .component-price-main"
                            )
                            .text("$" + calprice.toFixed(2));
                        } else $(this).find(".component-price").text() == "Free";
                      });
                    }
                    updateTotal();
                  }
                }
              );
            }
          }
        }
      }
    }
  );
}
